<template>
	<div class="themactlist-index f-row-b">
		
		<div class="signle pinter" v-for="(item,index) in list" :key="index">
			<el-image fit='cover' :src="$imgUrl + item.breviaryMap_dictText" alt="" @click="toseethemact(item)">></el-image>
		</div>
		
	</div>
	
</template>

<script>


export default {
 
  data: function() {
    return {
		list:[],
	  
    };
  },
  
  mounted() {
		this.getSpecial();
  },
  
  methods: {
	    //跳转详情
		toseethemact(item){
			this.$router.push({ path: '/themactdetail?id=' + item.id });
		},
	  
		//专题活动
		getSpecial(){
			this.$get(`web/specialActivity/activityList?pageSize=4&&pageNo=1&column=createTime&order=desc`).then(res=>{
				  if(res.success){
						this.list = res.result.records
				  }
			})
		},
		
  },
  
   
};
</script>

<style scoped=" scoped" lang="scss">
	
.themactlist-index{
	.signle{
		width: calc(25% - 13px);
		.el-image{
			width: 100%;
			height: 188px;
		}
	}
}

</style>
